﻿import Splide from '@splidejs/splide';

class CarCarousel extends HTMLElement {
  connectedCallback() {
    new Splide(this, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '2rem',
      autoplay: true,
      speed: 500,
      interval: 5000,
      pagination: false,
      breakpoints: {
        1400: {
          perPage: 3,
        },
        1200: {
          perPage: 2,
        },
        700: {
          perPage: 1,
        },
      },
    }).mount();
  }
}

customElements.define('car-carousel', CarCarousel);
